<template>
  <div>
    <div class="admin-header">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="white">Order List</h1>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-top:2rem" class="container section-padding">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group filter-box">
            <h3>Filters</h3>
            <div class="form-group">
              <label for="type">Order Status:</label>
              <select class="form-control" id="type" v-model="orderStatus" @change="loadOrders">
                <option value="pending">Pending</option>
                <option value="fulfilled">Fulfilled</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>
          </div>
        </div>

        <!-- List of Orders -->
        <div class="container" v-if="processing">
          <div class="row space-loader d-flex align-items-center justify-content-center">
            <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
          </div>
        </div>

        <OrderCard v-else v-for="(order, orderIndex) in orders" :key="orderIndex" v-bind:order="order"
          v-on:edit-order="editOrder" />

      </div>
    </div>
  </div>
</template>

<script>
  import OrderCard from "@/components/Admin/OrderCard.vue";
  import api from "../../api/api";

  export default {
    components: {
      OrderCard,
    },
    data: function () {
      return {
        orderStatus: "pending",
        orders: {},
        processing: false,
      };
    },
    mounted() {
      this.loadOrders();
    },
    methods: {
      editOrder(id) {
        this.$router.push(`/admin/orders/${id}/edit`);
      },
      loadOrders() {
        this.processing = true;
        this.orders = {};
        api
          .getOrdersByStatus(this.orderStatus, 0, 0)
          .then((res) => {
            for (var i = 0; i < res.orders.length; i++) {
              this.$set(this.orders, res.orders[i].id, res.orders[i]);
            }
          })
          // .catch((err) => {
          //   console.log(err);
          // })
          .finally(() => {
            this.processing = false;
          });
      },
    },
  };
</script>